export default {"src":"/_next/static/media/CGNX.7adaed95.svg","height":18,"width":18};